import { ThemeProvider } from "@mui/material/styles";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import configureStore from "redux/configurations/configureStore";
import { theme } from "themes/theme";
import App from "./App";
import ErrorBoundary from "./ErrorBoundary";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
// import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { registerServiceWorker } from "./serviceworkers/inprocessServiceWorkers";

ReactDOM.render(
  <PersistGate loading={null} persistor={configureStore().persistor}>
    <Provider store={configureStore().store}>
      <React.StrictMode>
        <ErrorBoundary>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </ErrorBoundary>
      </React.StrictMode>
    </Provider>
  </PersistGate>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// serviceWorkerRegistration.unregister();
registerServiceWorker();
